import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/generate-total-scores', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/generate-total-scores', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const releaseScore = data => {
  return httpClient
    .post('/api/generate-total-scores/releases', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const generateTotalAvg = data => {
  return httpClient
    .post('/api/generate-total-scores/total-avg', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/generate-total-scores/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  releaseScore,
  formViewModel,
  generateTotalAvg
}
